import * as React from 'react';

import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedPersonalSpace } from './ConnectedPersonalSpace';
import { PersonalSpaceOwnProps } from './PersonalSpace';

export interface PersonalSpaceProviderProps extends PersonalSpaceOwnProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const PersonalSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'personal',
  subspaceName: undefined
};

export const PersonalSpaceProvider: React.FunctionComponent<PersonalSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={PersonalSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={true}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedPersonalSpace
        />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
